import React from 'react';
import { ToastProviderProps } from './types';

const ToastContext = React.createContext<ToastProviderProps | undefined>(undefined);

export const ToastProvider: React.FC = ({ children }) => {
    const [snackbarOpen, setSnackbarOpen] = React.useState<boolean>(false);
    const [message, setMessage] = React.useState<string>('');
    const [success, setSuccess] = React.useState<boolean>(false);

    const onToggleSnackbar = () => {
        setSnackbarOpen(!snackbarOpen);
    };

    const onMessage = (msg: string) => {
        setMessage(msg);
    };

    const onSuccess = () => {
        setSuccess(true);
    };

    const onError = () => {
        setSuccess(false);
    };

    return (
        <ToastContext.Provider
            value={{
                snackbarOpen,
                onToggleSnackbar,
                message,
                success,
                onSuccess,
                onError,
                onMessage,
            }}
        >
            {children}
        </ToastContext.Provider>
    );
};

export function useToast(): ToastProviderProps | undefined {
    const context = React.useContext(ToastContext);
    return context;
}

export default ToastContext;
